module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/triangle-orange@3x-b68530e984ec595b1f55fe820d2f18fd.png";